import type { ComponentTheme } from '../types/component-theme';

import { ThemeVariants } from './constants/theme-variants';

export default {
    slots: {
        top: 'pointer-events-none absolute inset-x-0 top-0 z-20 h-16 bg-linear-to-b',
        bottom: 'pointer-events-none absolute inset-x-0 bottom-29.75 z-20 h-20 bg-linear-to-b'
    },
    variants: {
        theme: {
            [ThemeVariants.Dark]: {
                top: 'from-slate-950/70 to-transparent',
                bottom: 'from-transparent via-slate-800/70 to-slate-900'
            },
            [ThemeVariants.Light]: {
                top: 'from-white/45 to-transparent',
                bottom: 'from-transparent via-slate-100/70 to-white'
            }
        }
    }
} satisfies ComponentTheme;
